/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I fix invalid JSON?`)
};

const es_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo arreglo un JSON inválido?`)
};

const de_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie behebe ich ungültiges JSON?`)
};

const nl_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe kan ik ongeldige JSON repareren?`)
};

const fr_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment puis-je corriger du JSON invalide ?`)
};

const it_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come risolvo un JSON non valido?`)
};

const pt_br2_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como corrigir JSON inválido?`)
};

const pt_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como posso corrigir JSON inválido?`)
};

const ja_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なJSONを修正するにはどうすればよいですか？`)
};

const zh_jf_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何修复无效的 JSON？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_faq4_q", locale)
	if (locale === "en") return en_jf_faq4_q(inputs)
	if (locale === "es") return es_jf_faq4_q(inputs)
	if (locale === "de") return de_jf_faq4_q(inputs)
	if (locale === "nl") return nl_jf_faq4_q(inputs)
	if (locale === "fr") return fr_jf_faq4_q(inputs)
	if (locale === "it") return it_jf_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_jf_faq4_q(inputs)
	if (locale === "pt") return pt_jf_faq4_q(inputs)
	if (locale === "ja") return ja_jf_faq4_q(inputs)
	return zh_jf_faq4_q(inputs)
};